export default "__VITE_ASSET__DmrT$kwW__";